import { HttpParams } from "@angular/common/http";
import { BaseApi } from "@edl-development/edl-common";
import { PagedModel } from "src/app/model/common/paged.model";

export abstract class ComplyBaseApi extends BaseApi {
    protected generatePagingParams(pagedModel: PagedModel) {
        let params = new HttpParams()
            .append('offset', String(pagedModel.offset))
            .append('limit', String(pagedModel.limit))
            .append('ascending', String(pagedModel.ascending ?? true))

        if (pagedModel.orderBy) {
            params = params.append('orderBy', this.convertParam(pagedModel.orderBy));
        }

        if (pagedModel.bid) {
            params = params.append('bid', String(pagedModel.bid));
        }

        if (pagedModel.searchBy) {
            params = params.append('searchBy', this.convertParam(pagedModel.searchBy));
        }

        if (pagedModel.type) {
            params = params.append('type', String(pagedModel.type));
        }

        if (pagedModel.status) {
            params = params.append('status', String(pagedModel.status));
        }

        return params;
    }
}